import { HubConnection } from '@microsoft/signalr';
import { useEffect } from 'react';

export const useSignalREvent = <
  Events extends Record<string, any>,
  EventKey extends keyof Events
>(
  connection: HubConnection | null,
  event: Extract<keyof Events, string>,
  callback: (data: Events[EventKey]) => void
) => {
  useEffect(() => {
    if (!connection) return;

    connection.on(event, callback);

    return () => {
      connection.off(event, callback);
    };
  }, [connection, event, callback]);
};
